import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 52px 0 40px 0;

  @media screen and (max-width: 960px) {
    padding: 24px 20px 32px 20px;
    border-radius: 0;
  }
`;

export const Container = styled.div`
  width: 624px;

  @media screen and (max-width: 960px) {
    width: 100%;
  }
`;

export const Line = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;

  @media screen and (max-width: 960px) {
    margin-bottom: 0px;
  }
`;

export const Back = styled.div`
  display: none;

  @media screen and (max-width: 960px) {
    display: block;
  }
`;

export const Title = styled.h2`
  width: 100%;
  max-width: 294px;
  font-weight: 700;
  font-size: 28px;
  color: ${(props) => props.theme.colors.primaryDark2};
  display: block;

  @media screen and (max-width: 960px) {
    display: none;
  }
`;

export const BreadCrumb = styled.div`
  display: block;
  margin-top: 10px;
  font-size: 14px;
  font-weight: 400;
  min-width: 370px;
  text-align: end;
  color: ${(props) => props.theme.colors.primaryDark2};

  @media screen and (max-width: 960px) {
    display: none;
  }

  #bar {
    color: ${(props) => props.theme.colors.secundary};
  }

  #link {
    color: ${(props) => props.theme.colors.secundary};

    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`;

export const SubContainer = styled.div`
  display: flex;
  align-items: end;

  .card-subcontainer {
    display: flex;
    flex-direction: column;
    margin: 0 0 32px 30px;
  }

  .title-subcontainer {
    font-size: 24px;
    font-weight: 700;
    color: ${(props) => props.theme.colors.primaryDark2};
    margin-bottom: 7px;
  }

  .desc-subcontainer {
    font-size: 16px;
    font-weight: normal;
    color: ${(props) => props.theme.colors.secundary};
    line-height: 21px;
  }
`;

export const Linha = styled.div`
  width: 100%;
  max-width: 624px;
  height: 1px;
  background-color: ${(props) => props.theme.colors.lightGray};
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;

  .title-infocontainer {
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 700;
    color: ${(props) => props.theme.colors.black};
    margin: 36px 0 24px 0;
  }

  h2 {
    font-weight: 700;
    font-size: 24px;
    color: ${(props) => props.theme.colors.primaryDark2};
  }

  .value {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 4px 0 20px 0;
    font-size: 14px;
    color: ${(props) => props.theme.colors.gray};

    @media screen and (max-width: 960px) {
      margin: 8px 0 20px 0;
    }

    .spotlight,
    .strong {
      display: inline-block;
    }

    .spotlight {
      font-weight: normal;
    }

    .strong {
      font-weight: 700;
    }
  }

  .credor {
    font-weight: 700;
    font-size: 16px;
    color: ${(props) => props.theme.colors.gray};
    margin-bottom: 8px;
  }

  .space-right {
    margin-right: 4px;
  }

  .options {
    display: flex;
    color: ${(props) => props.theme.colors.gray};
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 4px;
    line-height: 130%;
  }

  a {
    text-decoration: underline;
    color: ${(props) => props.theme.colors.primary};
    margin-left: 4px;
    cursor: pointer;
  }

  .date {
    font-weight: 700;
    margin-left: 4px;
  }

  @media screen and (max-width: 960px) {
    h2 {
      font-size: 20px;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 28px;
`;

export const Button = styled.button`
  height: 60px;
  color: ${(props) => props.theme.colors.primary};
  background: ${(props) => props.theme.colors.white};
  text-transform: uppercase;
  padding: 19px 24px;
  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.2);
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  font-size: 16px;
  font-weight: bold;
`;
